export default "__VITE_ASSET__B$qKAv$B__"